export default class IPlugin {
    /**
     * Set up plugin and amend Vue config if needed
     * @param Vue {VueConstructor}
     * @param config {Object}
     * @returns {Object}
     */
    setup(Vue, config) {
        return config;
    }
}